import { render, staticRenderFns } from "./AnnouncementPage.vue?vue&type=template&id=cee042fc&scoped=true"
import script from "./AnnouncementPage.vue?vue&type=script&lang=js"
export * from "./AnnouncementPage.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementPage.vue?vue&type=style&index=0&id=cee042fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cee042fc",
  null
  
)

export default component.exports